import React, { useEffect } from "react";
import FiltrosFilaCobranca from "./filtros";
import ListInfos from "./list-infos";
import TabelaCobranca from "./tabela-cobranca";
import { useOperadorCaixa } from "../../../../context/OperadorCaixaContext";
import { ModalErro } from "../../../Modal/components/erro";
import { useAuth } from "../../../../context/AuthContext";
import jwtDecode from "jwt-decode";

interface FilaCobrancaProps {
  handleOpenTab: (value: string) => void;
}

export default function FilaCobranca({ handleOpenTab }: FilaCobrancaProps) {
  const { loadData, data, loading } = useOperadorCaixa();
  const { cookies, } = useAuth()
  const decoded = jwtDecode(cookies?.token || '') as any;
  useEffect(() => {
    loadData({
      page: 0
    });
  }, []);

  return (
    <div className="flex max-h-full min-h-full  w-[99.9%] flex-col items-center rounded-md bg-white px-6 py-6">
      <FiltrosFilaCobranca />
      <div className="flex w-full items-center justify-center mt-2">
        <p className="font-bold text-coolGray-600 text-xl">CARTEIRA TOTAL - LOJA (OPERADOR CAIXA) - FILIAL {decoded?.id_loja}</p>
      </div>
      <ListInfos data={data} />
      <TabelaCobranca
        data={data}
        handleOpenTab={handleOpenTab}
        loading={loading}
      />
      <ModalErro />
    </div>
  );
}
